/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from "react";
import {IHomepage} from "../../../interfaces/aem/IHomepage";
import {useI18N} from "../../hoc/withI18N";

interface IProps {
    error?: string,
    resource: any,
    homepage: IHomepage,
    isObsolete?: boolean
}

export const ProductAlert: FunctionComponent<IProps> = ({ error, isObsolete, resource, homepage }) => {
    const translate = useI18N();

    if (error) {
        return <div className="container">
            <div className="product-page__alert product-page__alert--danger" dangerouslySetInnerHTML={{__html: homepage.ecomErrorText || translate(error)}}/>
        </div>;
    }

    if (isObsolete) {
        return <div className="container">
            <div className="product-page__alert product-page__alert--danger">
                {homepage.obsoleteProduct}
                {resource.productFinderQuery && <> - <a className={"p-link-thin"} href={resource.productFinderQuery}>{translate('view alternatives')}</a></>}
            </div>
        </div>
    }

    return null;
}
